// extracted by mini-css-extract-plugin
export default {"person":"EntryView_person_e1UdA","span2Sm":"EntryView_span2Sm_U6Cby","flex":"EntryView_flex_dSh0f"};